<template>
  <avatar-with-name
    v-if="!isEmpty(modelValue)"
    :user="modelValue"
    class="w-52"
  />
  <div v-else>-</div>
</template>
<script setup lang="ts">
import isEmpty from "lodash/isEmpty";

import AvatarWithName from "@/components/ui/AvatarWithName.vue";

import type { IUser } from "@/models/users";
import type { PropType } from "vue";

defineProps({
  modelValue: {
    type: Object as PropType<IUser>,
    required: true,
  },
});
</script>
